import type { ScanPagePreparation } from "@/lib/scanners";

/** One line for the scan card: what page preparation did, in original page numbers. */
export function preparationSummary(preparation: ScanPagePreparation | null | undefined): string | null {
  if (!preparation) return null;
  const rotated = preparation.kept.map((page, index) => [page, preparation.rotations[index]] as const).filter(([, angle]) => angle !== 0);
  const parts = [
    preparation.blank.length ? `Izbačene prazne stranice: ${preparation.blank.join(", ")}` : null,
    rotated.length ? `Okrenute stranice: ${rotated.map(([page, angle]) => `${page} (${angle}°)`).join(", ")}` : null,
    preparation.orientation_uncertain.length ? `Provjeri orijentaciju: ${preparation.orientation_uncertain.join(", ")}` : null,
  ].filter((part): part is string => part !== null);
  return parts.length ? `Izvorni sken: ${preparation.original_pages} stranica. ${parts.join(" · ")}` : null;
}
